import React from "react";
// material-ui components
import withStyles from "material-ui/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

const logo = require('assets/img/logo-nodizurc.png');

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    const brand = <img src={logo} width="100px" alt="logótipo do produto"/>;
    return (
      <div className={classes.section} id="products">
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>A Marca</h2>
            <h5 className={classes.description}>
              {brand} oferece uma gama de produtos de limpeza de qualidade
              superior. <br/>
              Surge em [20XX] com o produto de limpeza de paredes e tetos e desde então tem progredido e expandido a gama de produtos.
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Limpa Paredes e Tetos"
                description="Perfumado, anti-fungos ativo e desinfetante, não mancha e aviva as cores"
                icon={() => (<img style={{borderRadius: 10 + 'px'}} src={require('assets/img/products/p001.jpg')} alt="produto limpa paredes e tetos" width='100px' />)}
                iconColor="info"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Desincrustante"
                description="Limpeza de formações calcárias, resíduos de cimento e sujidade de pedra, mármores, etc."
                icon={() => (<img style={{borderRadius: 10 + 'px'}} src={require('assets/img/products/p002.jpg')} alt="produto desincrustante" width='100px' />)}
                iconColor="success"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Soda Cáustica"
                description="Efetivo na manutenção e desentupimento de canos."
                icon={() => (<img style={{borderRadius: 10 + 'px'}} src={require('assets/img/products/p003.jpg')} alt="soda cáustica" width='100px' />)}
                iconColor="danger"
                vertical
              />
            </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Desentupidor de Canos"
                description="Desentope poderosamente e eficazmente todos os canos de sua casa."
                icon={() => (<img style={{borderRadius: 10 + 'px'}} src={require('assets/img/products/p004.jpg')} alt="produto desentupidor de canos" width='100px' />)}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Limpa Recuperadores de Calor"
                description="Remove as manchas pretas de fumo, fuligem, alcatrão e gordura de vidros de lareiras e aquecedores."
                icon={() => (<img style={{borderRadius: 10 + 'px'}} src={require('assets/img/products/p005.jpg')} alt="produto limpa recuperadores de calor" width='100px' />)}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Limpa Juntas"
                description="Para limpeza de juntas em pastilhas/azulejos e tijoleira. Eficaz na remoção de calcário de sanitários."
                icon={() => (<img style={{borderRadius: 10 + 'px'}} src={require('assets/img/products/p006.jpg')} alt="produto limpa juntas" width='100px' />)}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea
                title="Tira Gorduras"
                description="Limpa eficazmente panelas, tachos e exaustores."
                icon={() => (<img style={{borderRadius: 10 + 'px'}} src={require('assets/img/products/p007.jpg')} alt="produto tira gorduras" width='100px' />)}
                iconColor="danger"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <InfoArea
                title="Branqueador"
                description="Branqueador e tira nódoas, ajuda eficazmente na limpeza da máquina."
                icon={() => (<img style={{borderRadius: 10 + 'px'}} src={require('assets/img/products/p008.jpg')} alt="produto branqueador" width='100px' />)}
                iconColor="danger"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/Nodizurc/Sections/ProductSection.jsx